import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Card, CardBody, Col, Row } from "reactstrap";
import { mediaUrl } from "../../../helpers/mediaHelper";

function SummaryItem({ label, value }) {
  return (
    <div className="client-dashboard-company__item">
      <div className="client-dashboard-company__label">{label}</div>
      <div className="client-dashboard-company__value">{value || "—"}</div>
    </div>
  );
}

SummaryItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

function ClientCompanyCard({ summary, t }) {
  const photoUrl = summary.photo ? mediaUrl(summary.photo) : "";
  const title =
    summary.tradingName ||
    summary.registeredCompanyName ||
    t("clientDashboardCompanyFallback", "Your company");

  return (
    <Card className="client-dashboard-section border-0 mb-4">
      <CardBody className="p-4">
        <div className="d-flex align-items-start gap-3 mb-4">
          <div className="client-dashboard-company__avatar">
            {photoUrl ? (
              <img src={photoUrl} alt="" />
            ) : (
              <i className="bx bx-buildings" aria-hidden="true" />
            )}
          </div>
          <div>
            <h5 className="client-dashboard-section__title mb-1">{title}</h5>
            <p className="text-muted mb-0">
              {t(
                "clientDashboardCompanySubtitle",
                "Company overview from your profile"
              )}
            </p>
          </div>
        </div>

        <Row className="g-3">
          <Col md={6}>
            <SummaryItem
              label={t(
                "clientDashboardRegisteredName",
                "Registered company name"
              )}
              value={summary.registeredCompanyName}
            />
          </Col>
          <Col md={6}>
            <SummaryItem
              label={t("clientDashboardTradingName", "Trading name")}
              value={summary.tradingName}
            />
          </Col>
          <Col md={6}>
            <SummaryItem
              label={t(
                "clientDashboardRegistrationNumber",
                "Company registration number"
              )}
              value={summary.companyRegistrationNumber}
            />
          </Col>
          <Col md={6}>
            <SummaryItem
              label={t("clientDashboardIndustrySector", "Industry sector")}
              value={summary.industrySector}
            />
          </Col>
          <Col md={6}>
            <SummaryItem
              label={t("clientDashboardPrimaryContact", "Primary contact")}
              value={summary.primaryContact}
            />
          </Col>
          <Col md={6}>
            <SummaryItem
              label={t("clientDashboardContactEmail", "Email")}
              value={summary.email}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

ClientCompanyCard.propTypes = {
  summary: PropTypes.shape({
    registeredCompanyName: PropTypes.string,
    tradingName: PropTypes.string,
    companyRegistrationNumber: PropTypes.string,
    industrySector: PropTypes.string,
    primaryContact: PropTypes.string,
    email: PropTypes.string,
    photo: PropTypes.string,
  }).isRequired,
  t: PropTypes.func,
};

export default withTranslation()(ClientCompanyCard);
